<template>
  <div class="loader" v-if="loading">
    <div class="loader-img">
      <img src="/static/img/loading.gif" alt="Now Loading..." width="80px" height="80px"/>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: this.$store.state.modal.isShow
      }
    },
    watch: {
      '$store.state.modal.isShow' (to, from) {
        this.loading = this.$store.state.modal.isShow
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Loading.vue?1ec1e1a2